import { Label } from "@/components/ui/label";
import { MASCARA_CARTAO, MASCARA_COD_SEGURANCA, MASCARA_MES_ANO } from "@/utils/Constants";
import { InputMask } from "@/components/ui/input-mask";
import { InputFormik } from "@/components/ui/input-formik";
import { useEffect } from "react";
import { BuscarCautelasCarrinhoDto } from "@/dtos/Request/RequestBuscarCautelasCarrinho";

interface FinalizarCompraCartaoCreditoFormProps {
    dadosResumo: BuscarCautelasCarrinhoDto,
    formaPagamento: number,
    token?: string,
    formik: any
}

export function FinalizarCompraCartaoCreditoForm(props: FinalizarCompraCartaoCreditoFormProps) {    
    useEffect(() => {
        props.formik.validateForm();
    }, [])

    return (
        <form className="grid gap-2" onSubmit={props.formik.handleSubmit}>
            <div className="grid gap-1">
                <Label htmlFor="nome">Nome no Cartão</Label>
                <InputFormik
                    tabIndex={1}
                    id="nome"
                    name="nome"
                    type="text"
                    placeholder="Nome no Cartão"
                    required
                    formik={props.formik}
                />
            </div>
            <div className="grid gap-1">
                <Label htmlFor="numeroCartao">Numero do Cartão</Label>
                <InputMask
                    tabIndex={2}
                    name="numeroCartao"
                    mask={MASCARA_CARTAO}
                    placeholder="0000.0000.0000.0000"
                    type="text"
                    id="numeroCartao"
                    formik={props.formik}
                />

            </div>
            <div className="grid gap-1">
                <Label htmlFor="nome">Data Vencimento</Label>

                <InputMask
                    tabIndex={3}
                    name="dataVencimento"
                    mask={MASCARA_MES_ANO}
                    type="text"
                    placeholder="MM/AA"
                    required
                    id="dataVencimento"
                    formik={props.formik}
                />

            </div>
            <div className="grid gap-1">
                <Label htmlFor="nome">Cód. Segurança</Label>
                <InputMask
                    tabIndex={4}
                    id="codSeguranca"
                    name="codSeguranca"
                    mask={MASCARA_COD_SEGURANCA}
                    type="text"
                    placeholder="000"
                    required
                    formik={props.formik}
                />

            </div>
        </form>
    )
}